// Dependencies
import { Component } from 'react';
import { connect } from 'react-redux';

import DateTag from 'components/atoms/DateTag';
import Icon from 'components/atoms/Icon';
import { OpenModal, PortType, RootState } from 'types';
import { SystemType } from 'types/system';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { twclsx } from 'utils/twclsx';

interface DateRangeShortcutComponentProps {
    openModelFunction: OpenModal;
    addDays: (days: number) => { next: boolean; perverse: boolean; today: boolean };
    applayDate: (clear?: boolean) => void;
    lastDay: DateTimeFormat;
    dateRange: string;
    system: SystemType;
    port: PortType;
}

interface DateRangeShortcutComponentState {
    dateRange: string;
    lastDay: DateTimeFormat;
    next: boolean;
    perverse: boolean;
    today: boolean;
    days: number;
}

class DateRangeShortcut extends Component<DateRangeShortcutComponentProps, DateRangeShortcutComponentState> {
    constructor(props: DateRangeShortcutComponentProps) {
        super(props);
        this.state = {
            lastDay: props.lastDay,
            next: false,
            perverse: true,
            today: false,
            dateRange: props.dateRange,
            days: 0,
        };
    }

    static getDerivedStateFromProps(props: DateRangeShortcutComponentProps, state: DateRangeShortcutComponentState) {
        if (props.dateRange !== state.dateRange) {
            return {
                dateRange: props.dateRange,
                //@ts-ignore
                //  days: props.dateRange === 'activeDays' && props.dateRange !== 'activeToday' ? 0 : state.days,
            };
        }

        return null;
    }

    addDays = (days: number): boolean | void => {
        if ((this.state.dateRange === 'activeDays' || this.state.dateRange === 'activeToday') && days === 0) {
            this.props.applayDate(true);
            return;
        }

        const { next, perverse } = this.state;

        if (days === 1 && !next) {
            return false;
        }

        if (days === -1 && !perverse) {
            return false;
        }
        this.setState({ days: days === 0 ? 0 : this.state.days - days }, () => {
            const { next: newNext, perverse: newPerverse, today } = this.props.addDays(days * -1);
            this.setState({ next: newNext, perverse: newPerverse, today });
        });
    };

    render() {
        return (
            <>
                <DateTag
                    active={this.state.dateRange === 'activeDays' || this.state.dateRange === 'activeToday'}
                    className="flex gap-x-1 px-1"
                >
                    <div
                        onClick={() => {
                            this.addDays(-1);
                        }}
                    >
                        <Icon className={twclsx('w-arrow', 'h-arrow', !this.state.perverse && 'opacity-30')}>
                            <path d="M15 6l-6 6l6 6"></path>
                        </Icon>
                    </div>
                    <div
                        className={twclsx('no-select', 'h-arrow', this.state.today && 'font-bold')}
                        onClick={() => {
                            this.addDays(0);
                        }}
                    >
                        {this.props.lastDay.formatDateTimeToString('dd LLL')}
                    </div>
                    <div
                        onClick={() => {
                            this.addDays(1);
                        }}
                    >
                        <Icon className={twclsx('w-arrow', 'h-arrow', !this.state.next && 'opacity-30')}>
                            <path d="M9 6l6 6l-6 6"></path>
                        </Icon>
                    </div>
                </DateTag>
            </>
        );
    }
}

const daterangeshortcutStateToProps = (state: RootState) => ({
    openModelFunction: state.layout.openModelFunction,
    port: state.port.port,
    system: state.port.system,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const daterangeshortcutDispatchToProps = () => ({});

export default connect(daterangeshortcutStateToProps, daterangeshortcutDispatchToProps)(DateRangeShortcut);
